import telegramSVG from '../assets/img/telegram.svg';
import whatsapSvg from '../assets/img/whatsapp.svg';
import instagramSVG from '../assets/img/instagram.svg';

const Footer = () => {
	return (
		<footer className='footer'>
			<div className='footer__container'>
				<ul className='footer__wrapper'>
					<li className='footer__blocks'>
						<a className='footer__logo' href='home.html'></a>
						<p className='footer__logo-text'>
							Логистическая компания по поиску, выкупу, доставки товаров из
							Китая.
						</p>
					</li>
					<li className='footer__blocks footer__blocks--second'>
						<div className='footer__inner'>
							<a
								className='footer__links footer__links-location'
								href='https://go.2gis.com/nV6bQ' target='_blank'>
								Кыргызстан, Бишкек
								<span className='footer__location-span'>Бегматова 31</span>
							</a>
						</div>
						<div className='footer__inner'>
							<a
								className='footer__links footer__links-location'
								href='https://go.2gis.com/h5DBJ' target='_blank'>
								Микрорайон Джал
								<span className='footer__location-span'>Микрорайон Джал-23, 103/1</span>
							</a>
						</div>
						<div className='footer__inner'>
							<a
								className='footer__links footer__links-location'
								href='https://go.2gis.com/Tw5s3' target='_blank'>
								Кыргызстан, Ош
								<span className='footer__location-span'>Алиева 219</span>
							</a>
						</div>

						<div className='footer__inner'>
							<a
								className='footer__links footer__links--phone'
								href='tel:+996225905055'>
								<span />
								+996 225 905 055
							</a>
							<a
								className='footer__links footer__links--phone'
								href='tel:+996997905055'>
								<span />
								+996 997 905 055
							</a>

							<span className='footer__links footer__links--time'>
								<span />
								12:00-19:00
							</span>
						</div>
					</li>
					<li className='footer__blocks footer__blocks--social'>
						<a className='footer__social' href='https://t.me/+Yn4OkYESMvU5Mjky'>
							<img src={telegramSVG} alt='' width={25} height={25} />
						</a>
						<a className='footer__social' href='https://wa.me/996225905055'>
							<img src={whatsapSvg} alt='' width={25} height={25} />
						</a>
						<a
							className='footer__social'
							href='https://instagram.com/ades_express_cargo?igshid=NzZlODBkYWE4Ng=='>
							<img src={instagramSVG} alt='' width={25} height={25} />
						</a>
					</li>
				</ul>
			</div>
		</footer>
	);
};

export default Footer;
